import { Tooltip } from 'antd';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import Col from 'antd/lib/col';
import Collapse from 'antd/lib/collapse';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import Modal from 'antd/lib/modal';
import Row from 'antd/lib/row';
import Select from 'antd/lib/select';
import Spin from 'antd/lib/spin';
import * as LogRocket from 'logrocket';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { sendInquiry } from 'src/api/inquiry';
import { fetchLinkedFFs, fetchOrganisationFFGroups } from 'src/api/masters';
import FieldRate from 'src/components/common/form/FieldRate';
import TextNoWrap from 'src/components/common/TextNoWrap';
import { fetchStrategicVendorList } from 'src/Library/Common';
import { commonStyles } from 'src/Library/CommonStyles';
import { InquiryModes } from 'src/Library/Constants';
import { isValidArray } from 'src/Library/Helper';
import { KeyLabel } from 'src/Library/Types';
import { getFFDimensions } from 'src/selectors/importsFilter';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { arrayToObject } from 'src/utils/utils';
import { FFType } from '../../DiscoverRate/DiscoverRateUtils';
import { renderInquiryDestinationDetails, renderInquiryOriginDetails } from '../Cards/InquiryCommon';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  '& .select-btn': {
    width: '100%',
  },
  dropdown: {
    width: '100%',
  },
  multiselect: {
    '& .ant-select': {
      color: 'black',
    },
    '& .ant-select-selected-icon': {
      color: 'blue ',
    },
    '& .ant-select-selection': {
      color: 'green',
      fontSize: `${tokens.fontSize.small}px`,
    },
    '& .ant-checkbox-disabled .ant-checkbox-inner': {
      backgroundColor: '#b0e0aa',
    },
  },
  modalStyle: {
    width: '560px !important',
    '& .ant-modal-content': {
      minHeight: '506px',
    },
    '& .ant-modal-header': {
      padding: 0,
    },
    '& .ant-modal-footer': {
      fontSize: `${tokens.fontSize.small}px`,
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '100%',
    },
  },
  countryNameStyle: {
    color: '#262626',
    fontSize: `${tokens.fontSize.body}px`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: tokens.fontWeight.semibold,
    width: '80px',
    textAlign: 'center',
  },
  modal: {
    width: '560px !important',
    '& .ant-modal-content': {
      minHeight: '460px !important',
    },
    '& .ant-modal-footer': {
      fontSize: `${tokens.fontSize.small}px`,
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '100%',
    },
  },
  ffType: {
    backgroundColor: '#FFE7D5',
    border: '1px solid #FFC59A',
    padding: '0px 4px',
    marginLeft: '5px',
    fontSize: `${tokens.fontSize.caption}px`,
    borderRadius: `${tokens.radius.sm}px`,
  },
  groupType: {
    backgroundColor: '#EDE3FC',
    border: '1px solid #A082CE',
    padding: '0px 4px',
    marginLeft: '5px',
    fontSize: `${tokens.fontSize.caption}px`,
    borderRadius: `${tokens.radius.sm}px`,
  },
  optionsDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: 12,
  },
  sentBidStyle: {
    color: '#b0e0aa',
    fontSize: `${tokens.fontSize.small}px`,
  },
  selectedFFsPanel: {
    ...commonStyles(theme).justifySpaceBetween,
    fontWeight: tokens.fontWeight.semibold,
  },
  collapseDiv: {
    border: 0,
    backgroundColor: 'unset',
    color: tokens.colors.textSecondary,
    width: '100%',
    '& .ant-collapse-header': {
      fontWeight: tokens.fontWeight.semibold,
      padding: '12px 10px !important',
      paddingLeft: '24px !important',
      '& .ant-collapse-arrow': {
        left: '0 !important', 
      },
    },
    '& .ant-collapse-content': {
      borderTop: 0,
      fontSize: `${tokens.fontSize.small}px`,
      padding: '0 10px 0 24px',
      '& .ant-collapse-content-box': {
        padding: '0 0 14px 0',
      },
    },
  },
  ffList: {
    ...commonStyles(theme).fixedScrollbar,
    maxHeight: '120px',
    overflow: 'auto',
    marginTop: '8px',
  },
  addressDetails: {
    flexDirection: 'row',
    width: '125px',
    height: '35px',
    paddingRight: '5%',
    ...commonStyles(theme).ellipses,
  },
  selectedRowContainer: {
    padding: `${tokens.spacing.xs}px 0`,
    borderBottom: `1px solid ${tokens.colors.border}`,
  },
  selectedRowLabel: {
    fontSize: `${tokens.fontSize.small}px`,
    color: tokens.colors.text,
    marginTop: `${tokens.spacing.xs}px`,
    paddingLeft: `${tokens.spacing.xs}px`,
    display: 'flex',
    alignItems: 'center',
  },
  closeRowIcon: {
    width: '9.33px',
    height: '9.33px',
    color: tokens.colors.textSecondary,
    marginTop: `${tokens.spacing.ms}px`,
    cursor: 'pointer',
  },
  groupVendorsList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${tokens.spacing.xs}px`,
    padding: `${tokens.spacing.xs}px ${tokens.spacing.xs}px ${tokens.spacing.xs}px ${tokens.spacing.ms}px`,
  },
  groupVendorTag: {
    backgroundColor: tokens.colors.bgSubtle,
    color: tokens.colors.textSecondary,
    padding: `${tokens.spacing.xxs}px ${tokens.spacing.sm}px`,
    fontSize: `${tokens.fontSize.caption}px`,
    borderRadius: `${tokens.radius.sm}px`,
    border: `1px solid ${tokens.colors.border}`,
  },
  groupEmpty: {
    padding: `${tokens.spacing.xxs}px ${tokens.spacing.ms}px`,
    fontSize: `${tokens.fontSize.caption}px`,
    color: tokens.colors.textTertiary,
    fontStyle: 'italic',
  },
});

const COLOR = {
  GREY : '#979797',
};

class SendRFQ extends React.Component<any, any> {
  state = {
    checkedList: [] as any[],
    checkAll: false,
    isLoading: false,
    selectAll: false,
    showRows: false,
    fetchingFFs: false,
    fetchedFFs: [],
    mapFetchedFFs: {} as Record<string, { key: string; label: string; isGroup: boolean; rating?: number }>,
    strategicFFs: [],
    selectedStrategicFFs: [],
    isAllStrategicFFsSelected: false,
    groupVendorsMap: {} as Record<string, Array<{ id: string; name: string }>>,
  };

  async componentDidMount() {
    const { inquiryMode, showDiscoverBuyRates, hideStrategicVendors } = this.props;
    this.setState({
      fetchingFFs: true,
    });
    const responses = await Promise.all([
      fetchLinkedFFs({
        organisationType: 'FF',
        mode: (inquiryMode === 'AIRCARGO' ? 'AIR' : inquiryMode),
      }),
      fetchOrganisationFFGroups({}),
    ]);
    let fetchedFFs: any[] = [];
    const groupVendorsMap: Record<string, Array<{ id: string; name: string }>> = {};
    responses.forEach((response: any, index) => {
      if (!response.isSuccess) {
        message.error(response.errorMessage);
      }
      const isGroupResponse = index !== 0;
      const formatResponse = response.data ? response.data.map((item) => {
        if (!isGroupResponse && isValidArray(item?.groupIds)) {
          item.groupIds.forEach((groupId: string) => {
            if (!groupId) return;
            if (!groupVendorsMap[groupId]) groupVendorsMap[groupId] = [];
            groupVendorsMap[groupId].push({ id: item.id, name: item.name });
          });
        }
        return {
          key: item.id,
          label: item.name,
          isGroup: isGroupResponse,
          rating: item?.rating,
        };
      }) : [];
      fetchedFFs = [...fetchedFFs, ...formatResponse];
    });
    const ffList = fetchedFFs?.map(item => item.key) || [];
    const strategicFFs = showDiscoverBuyRates && !hideStrategicVendors ? await fetchStrategicVendorList(ffList, [], inquiryMode) : [];
    this.setState({
      strategicFFs,
      fetchedFFs,
      fetchingFFs: false,
      mapFetchedFFs: arrayToObject(fetchedFFs, 'key'),
      groupVendorsMap,
    });
  }

  updateRows = (element, type) => {
    const selectedFFList = this.getValueFromKeyMap(type, 'selectedFFList');
    const selectedFFListKey = this.getValueFromKeyMap(type, 'selectedFFListKey');
    this.setState(
      {
        [selectedFFListKey]: selectedFFList?.filter((elem: any) => elem.key !== element),
      },
    );
  }

  renderGroupVendors = (groupId: string) => {
    const { classes } = this.props;
    const { groupVendorsMap } = this.state;
    const vendors = groupVendorsMap?.[groupId] || [];
    if (!isValidArray(vendors)) {
      return (
        <div className={classes.groupEmpty}>No vendors linked</div>
      );
    }
    return (
      <div className={classes.groupVendorsList}>
        {vendors.map((vendor) => (
          <span key={vendor.id} className={classes.groupVendorTag}>{vendor.name}</span>
        ))}
      </div>
    );
  }

  renderRow = (type) => {
    const { classes } = this.props;
    const { mapFetchedFFs }: any = this.state;
    const ffList = this.getValueFromKeyMap(type, 'selectedFFList');
    const checks = ffList.map((element) => {
      const ffMeta = type === FFType.MY_FF ? mapFetchedFFs?.[element.key] : undefined;
      const isGroup = !!ffMeta?.isGroup;
      return (
        <div className={classes.selectedRowContainer} key={element.key}>
          <Row>
            <Col span={23}>
              <h5 className={classes.selectedRowLabel}>
                {element.value}
                {isGroup && <span className={classes.groupType}>Group</span>}
              </h5>
            </Col>
            <Col span={1}>
              <div onClick={() => this.updateRows(element.key, type)}>
                <Icon className={classes.closeRowIcon} type="close" />
              </div>
            </Col>
          </Row>
          {isGroup && this.renderGroupVendors(element.key)}
        </div>
      );
    });
    return checks;
  }

  getCheckedFFs = (isGroup) => {
    const { checkedList, mapFetchedFFs }: any = this.state;
    return checkedList.filter((ff: any) => {
      return mapFetchedFFs[ff.key].isGroup === isGroup;
    }).map((ff: any) => {
      return ff.key;
    });
  }

  handleCreate = async () => {
    const { fromCreateInquiry } = this.props;
    const { selectedStrategicFFs } = this.state;
    if (fromCreateInquiry) {
      sendEvent(
        EventCategories.INQUIRY_CREATION,
        'Create Inquiry - Send',
      );
    } else {
      sendEvent(
        EventCategories.INQUIRY_SEND,
        'Send Inquiry',
      );
    }
    this.setState({
      isLoading: true,
    });
    const ffIds = this.getCheckedFFs(false);
    const ffGroupIds = this.getCheckedFFs(true);
    const strategicFFs = selectedStrategicFFs?.map((item: KeyLabel) => item.key);

    const body = {
      strategicFFs, 
      inquiryId: this.props.inquiryId,
      ...(ffIds.length && {
        ffIds,
      }),
      ...(ffGroupIds.length && {
        ffGroupIds,
      }),
    };
    const response = await sendInquiry(body);
    this.setState({
      isLoading: false,
    });
    if (response.isSuccess) {
      message.success('Inquiry sent successfully');
      LogRocket.track('Inquiry sent');
      this.handleSuccess();
    } else {
      if (fromCreateInquiry) {
        sendEvent(
          EventCategories.INQUIRY_CREATION,
          'Create Inquiry - Send Failed',
        );
      } else {
        sendEvent(
          EventCategories.INQUIRY_SEND,
          'Send Inquiry Failed',
        );
      }
      message.error(response.errorMessage);
    }
  }

  resetSelectedVendorsState = () => {
    this.setState({
      checkedList: [],
      selectAll: false,
      selectedStrategicFFs: [],
      isAllStrategicFFsSelected: false,
    });
  }

  handleSuccess = () => {
    const { handleOk } = this.props;
    this.resetSelectedVendorsState();
    handleOk();
  }

  handleChange = (options, type) => {
    const ffList = this.getValueFromKeyMap(type, 'ffList');
    const selectedFFList = this.getValueFromKeyMap(type, 'selectedFFList');
    const selectAllKey = this.getValueFromKeyMap(type, 'selectAllKey');
    const isSelectAll = this.getValueFromKeyMap(type, 'isSelectAll');
    const selectedFFListKey = this.getValueFromKeyMap(type, 'selectedFFListKey');

    if (options[0].key === 'all') {
      this.setState({
        [selectAllKey]: !isSelectAll,
        [selectedFFListKey]: !isSelectAll ?
          ffList.map((ff: KeyLabel) => ({ key: ff.key, value: ff.label })) : [],
      });
    } else {
      const findRes = selectedFFList?.find(
        filter => filter.key === options[0].key);
      findRes ?
        this.setState({
          [selectAllKey]: false,
          [selectedFFListKey]:
            selectedFFList?.filter(fil => fil.key !== options[0].key),
        })
        : this.setState({
          [selectedFFListKey]: [...selectedFFList,
            {
              key: options[0].key,
              value: options[0].props['data-value'] || options[0].props.value,
            },
          ],
        },
          () => {
            selectedFFList?.length === ffList?.length ?
              this.setState({ [selectAllKey]: true }) :
              this.setState({ [selectAllKey]: false });
          },
        );
    }
  }

  renderSelectFFsOptions = () => {
    const { selectedStrategicFFs, isAllStrategicFFsSelected, strategicFFs } = this.state;
    const { sentFfIds, classes } = this.props;
    return (
      strategicFFs?.map((ff : KeyLabel) => (
        <Select.Option
          style={{ display: 'flex' }}
          key={ff.key}
          value={ff.label}
          disabled={sentFfIds?.indexOf(ff.key) !== -1}
        >
          <Checkbox
            key={ff.key}
            checked={selectedStrategicFFs?.some((item: KeyLabel) => item.key === ff.key)
              || isAllStrategicFFsSelected || sentFfIds?.indexOf(ff.key) !== -1}
            disabled={sentFfIds?.indexOf(ff.key) !== -1} />
          <span className={classes.optionsDiv}>
            {ff.label}
            <span className={classes.sentBidStyle}>
              {sentFfIds?.indexOf(ff.key) !== -1 ? 'Sent' : ''}
            </span>
          </span>
        </Select.Option>
      ))
    )
  }

  getVendorLabel = () => {
    const { inquiryMode } = this.props;
    const vendorLabel = inquiryMode === InquiryModes.TRAILER || inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL ? 'Trucking Agent(s)' : 'Forwarder(s)';
    return vendorLabel;
  }

  generateOptions = () => {
    const { sentFfIds, classes, inquiryMode, vendorRating } = this.props;
    const { fetchedFFs } = this.state;
    const ffSentMap = new Map();
    const selectedFfs: any = new Set(this.state.checkedList.map(check => check.key));
    sentFfIds.forEach(ff => ffSentMap.set(ff, 1));
    const vendorLabel = inquiryMode === InquiryModes.TRAILER || inquiryMode === InquiryModes.DOMESTIC ? 'Trucker' : 'FF';
    
    /** Sorting so that sent FFs comes on top */
    const sortedFFs = [...fetchedFFs].sort((a: any, b: any) => {
      const aIsSent = ffSentMap.has(a.key);
      const bIsSent = ffSentMap.has(b.key);
      
      if (aIsSent && !bIsSent) return -1; // a comes first
      if (!aIsSent && bIsSent) return 1;  // b comes first
      return a.label.localeCompare(b.label); // alphabetical for same status
    });

    const options = sortedFFs.map((item: any) => {
      return (
        <Select.Option
          key={item.key}
          disabled={ffSentMap.has(item.key)}
          value={item.key}
          data-value={item.label}
        >
          <div style={{ display: 'flex' }}>
            <Checkbox
              checked={selectedFfs.has(item.key) || ffSentMap.has(item.key) ? true : false}
              disabled={ffSentMap.has(item.key) ? true : false}
            ></Checkbox>
            <div className={classes.optionsDiv}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <TextNoWrap
                  maxChars={23}
                  value={item.label}
                  placement="topLeft"
                  style={{ width: '230px' }}
                />
                <span className={classes.sentBidStyle}>
                  {ffSentMap.has(item.key) ? 'Sent' : ''}
                </span>
                <span className={item.isGroup ? classes.groupType : classes.ffType}>
                  {item.isGroup ? 'Group' : vendorLabel}
                </span>
              </div>
              {!item.isGroup ? (
                <Tooltip title={item?.rating ? vendorRating[item.rating - 1] : ''}>
                  <div style={{ display: 'flex', justifyItems: 'right' }}>
                    <FieldRate
                      isView={true}
                      isFlex={true}
                      styles={{ fontSize: `${tokens.fontSize.caption}px` }}
                      disabled={true}
                      value={item?.rating}
                    />
                  </div>
                </Tooltip>
              ) : (
                ''
              )}
            </div>
          </div>
        </Select.Option>
      );})
    return options;
  }

  isSelectAllChecked = (type) => {
    const selectedFFList = this.getValueFromKeyMap(type, 'selectedFFList');
    const ffList = this.getValueFromKeyMap(type, 'ffList');
    const isSelectAll = this.getValueFromKeyMap(type, 'isSelectAll');
    return selectedFFList.length === ffList.length || isSelectAll;
  }

  isSelectAllDisabled = (type) => {
    const { sentFfIds } = this.props;
    const ffList = this.getValueFromKeyMap(type, 'ffList');
    return ffList?.some((item : KeyLabel) => sentFfIds?.indexOf(item.key) !== -1);
  }

  renderSelect = (type) => {
    const { classes } = this.props;
    const { fetchingFFs } = this.state;
    const vendorLabel = this.getVendorLabel();
    return <Row style={{ width: '100%' }}>
    <Col span={22}>
      <div style={{ width: '100%' }}>
        <Select
          mode="multiple"
          disabled={fetchingFFs}
          className={classes.multiselect}
          placeholder={`Search & Select ${vendorLabel}`}
          dropdownClassName={classes.multiselect}
          showSearch={true}
          showArrow
          value={[]}
          autoClearSearchValue={false}
          style={{ width: '100%' }}
          onDropdownVisibleChange={open => !open ? this.setState({ showRows: true }) :
            this.setState({ showRows: false })}
          onChange={(filtervals, options) => { this.handleChange(options, type); }}
          optionFilterProp={type === FFType.STRATEGIC_FF ? 'value' : 'data-value'}
        >
          <Select.Option key="all" value="all"
            disabled={this.isSelectAllDisabled(type)}>
              <Checkbox
                checked={this.isSelectAllChecked(type)}
                key="all"
                disabled={this.isSelectAllDisabled(type)}
              />
              <div style={{ display: 'inline-block', marginLeft: 12 }}>Select All</div>
          </Select.Option>
          {type === FFType.STRATEGIC_FF ? this.renderSelectFFsOptions() : this.generateOptions()}
        </Select>
      </div>
      {/* {this.state.showRows ? */}
      <div className={classes.ffList}>{this.renderRow(type)}</div>
      {/* : <div></div>} */}
    </Col>
  </Row>;
  }

  renderDot = (style) => {
    return <div style={{
      marginBottom: '3px', height: '8px', width: '8px',
      borderRadius: `${tokens.radius.md}px`, display: 'inline-block',
      verticalAlign: 'middle',
      ...style,
    }}></div>;
  }

  renderLine = (color) => {
    return <div style={{ display: 'flex', flex: 1,
      marginTop: '3px', height: '2px', backgroundColor: color }}>
    </div>;
  }

  getFlagComponent = () => {
    const { classes, countriesList, inquiryData,
      originCountry,
      destinationCountry,
    } = this.props;
    const destinationPortCountry = inquiryData.data.destination &&
    inquiryData.data.destination?.countryCode;

    const destinationCountryToShow = destinationCountry === destinationPortCountry ?
    undefined : destinationPortCountry;

    const destinationPort = inquiryData.data.destination &&
    inquiryData.data.destination?.destinationPortName;

    const destinationFlag = destinationCountry &&
    countriesList.filter(country => country.countryCode === destinationCountry)[0].flagS3Link;

    const originPortCountry = inquiryData.data.origin &&
    inquiryData.data.origin?.countryCode;

    const originCountryToShow = originCountry === originPortCountry ?
      undefined : originPortCountry;
    const originPort = inquiryData.data.origin &&
    inquiryData.data.origin?.originPortName;

    const originFlag = originCountry &&
    countriesList.filter(country => country.countryCode === originCountry)[0].flagS3Link;

    if ((!destinationPortCountry || !originPortCountry || !originPort || !destinationPort) &&
      (inquiryData.data?.mode !== InquiryModes.TRAILER 
        && inquiryData.data?.mode !== InquiryModes.DOMESTIC 
        )){ return };

    return <div style={{
      justifyContent: 'space-between',
      alignItems: 'center',
      maxHeight: '120px',
      display: 'flex',
      flexDirection: 'column',
      width: '75%',
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      paddingLeft: "5px",
      marginBottom: "5px"
    }}>
      <div style={{ display: 'flex', flexDirection: 'row',
        marginBottom: '8px', width: '75%' }}>
        {this.renderDot({ backgroundColor: '#979797' })}
        {this.renderLine('#979797')}
        {this.renderDot({ border: `1px solid ${'#979797'}` })}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row',
        width: '100%', justifyContent: 'space-between' }}>
          <div className={classes.absoluteData} style={{
            left: '22px',
            width: '80px', display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            {(inquiryData.data?.mode === InquiryModes.TRAILER || inquiryData.data?.mode === InquiryModes.DOMESTIC ) ?
              renderInquiryOriginDetails(classes, inquiryData?.data) :
              <React.Fragment>
                <img src={originFlag} style={{ width: '27px', height: '19px' }} />
                <span className={classes.countryNameStyle}>
                  {originPort}
                </span>
                {originCountryToShow && <div style={{
                  fontSize: '8px', fontWeight: 800, fontStyle: 'italic',
                  width: '92px', marginLeft: '36px',
                }}>
                  <div>Origin Country</div>
                  <div className={classes.addressDetails}>{originCountryToShow.length > 0 && countriesList.filter(
                    item => item.countryCode === originCountryToShow)[0].countryName}</div>
                </div>}
              </React.Fragment>
            }
          </div>
        <div className={classes.absoluteData} style={{ right: '100px', width: '80px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          {(inquiryData.data?.mode === InquiryModes.TRAILER) ? 
          renderInquiryDestinationDetails(classes, inquiryData.data) 
          : (inquiryData.data?.mode === InquiryModes.DOMESTIC)
            ? (renderInquiryDestinationDetails(classes, inquiryData.data)) 
            :
            <React.Fragment>
              <img src={destinationFlag} style={{ width: '27px', height: '19px' }}/>
              <span className={classes.countryNameStyle}>
                {destinationPort}
              </span>
              {destinationCountryToShow && <div style={{
                fontSize: '8px', fontWeight: 800, fontStyle: 'italic',
                width: '92px', marginLeft: '28px',
              }}>
                <div>Destination Country</div>
                <div className={classes.addressDetails}>{destinationCountryToShow.length > 0 && countriesList.filter(
                  item => item.countryCode === destinationCountryToShow)[0].countryName}</div>
              </div>}
            </React.Fragment>
          }
        </div>
      </div>
    </div>;
  }

  getValueFromKeyMap = (type: string, option: string) => {
    const {
      selectedStrategicFFs,
      checkedList,
      strategicFFs,
      isAllStrategicFFsSelected,
      fetchedFFs,
      selectAll,
    } = this.state;
    let keyMap;
    if (type === FFType.STRATEGIC_FF) {
      keyMap = {
        selectedFFList: selectedStrategicFFs,
        selectedFFListKey: 'selectedStrategicFFs',
        ffList: strategicFFs,
        selectAllKey: 'isAllStrategicFFsSelected',
        isSelectAll: isAllStrategicFFsSelected,
      }
    } else {
      keyMap = {
        selectedFFList: checkedList,
        selectedFFListKey: 'checkedList',
        ffList: fetchedFFs,
        selectAllKey: 'selectAll',
        isSelectAll: selectAll,
      }
    }
    return keyMap[option];
  }

  renderFFSelection = () : React.ReactElement => {
    const { classes, showDiscoverBuyRates, hideStrategicVendors, inquiryMode } = this.props;
    const { strategicFFs, selectedStrategicFFs, checkedList, fetchingFFs } = this.state;
    const vendorLabel = this.getVendorLabel();
    return (
      <Collapse
        accordion
        defaultActiveKey="1"
        className={classes.collapseDiv}
      >
        <Collapse.Panel
          header={
            <div className={classes.selectedFFsPanel}>
              <span>My {vendorLabel}</span>
              {isValidArray(checkedList) && <span>({checkedList?.length})</span>}
            </div>
          }
          style={{
            borderTop: '1px solid #d9d9d9',
          }}
          key="1">
          {this.renderSelect(FFType.MY_FF)}
        </Collapse.Panel>
        {/* disable strategic Trucker for Domestic inquiries for now */}
        {(isValidArray(strategicFFs) && showDiscoverBuyRates && !hideStrategicVendors && (inquiryMode !== InquiryModes.DOMESTIC)) && <Collapse.Panel
          header={
            <div className={classes.selectedFFsPanel}>
              <span>Shipsy's {vendorLabel}</span>
              {isValidArray(selectedStrategicFFs) && <span>({selectedStrategicFFs?.length})</span>}
            </div>
          }
          key="2"
          style={{
            borderBottom: 0,
          }}>
          {this.renderSelect(FFType.STRATEGIC_FF)}
        </Collapse.Panel>}
      </Collapse>
    )
  }

  handleClose = () => {
    const { handleCancel } = this.props;
    this.resetSelectedVendorsState();
    handleCancel();
  }

  render() {
    const { visible,
      classes, fromCreateInquiry,
      inquiryData, countriesList, showDiscoverBuyRates, hideStrategicVendors } = this.props;
    const { selectedStrategicFFs, checkedList, fetchingFFs, strategicFFs } = this.state;
    const protipHeader = inquiryData && inquiryData.data &&
    inquiryData.data?.referenceNumber && <div style={{
      color: '#424242', fontFamily: 'Open Sans',
      fontSize: `${tokens.fontSize.body}px`, lineHeight: '19px',
      display: 'flex',
      padding: '24px 24px 0px 24px',
      background: '#F9F9F9',
      borderRadius: '5px',
    }}>
      <div>
        <Icon type="check-circle" theme="filled"
          style={{ color: '#52C41A', fontSize: `${tokens.fontSize.h1}px`,
            marginRight: '10px',
          }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          Inquiry <strong>{inquiryData.data?.referenceNumber} </strong>
          has been {inquiryData.type} successfully.
        </div>
        {inquiryData.data.deadline &&
          <div style={{ fontSize: `${tokens.fontSize.small}px`, marginTop: '8px', marginBottom: '10px' }}>
            <Icon type="hourglass" style={{ marginRight: '11px', fontSize: `${tokens.fontSize.body}px` }} />
            {(() => {
              const deadlineMoment = this.props.timezone
                ? momentTimezone(inquiryData.data.deadline).tz(this.props.timezone)
                : moment(inquiryData.data.deadline);
              return deadlineMoment.format('DD MMMM, YYYY | HH:mm') + 'Hrs';
            })()}
          </div>
        }
      </div>
    </div>;

    return (
      <Modal
        width={fromCreateInquiry ? '454px' : undefined}
        className={fromCreateInquiry ? classes.modalStyle : classes.modal}
        title={fromCreateInquiry ? protipHeader : 'Send Inquiry'}
        closable={fromCreateInquiry ? false : true}
        visible={visible}
        destroyOnClose
        onOk={this.handleSuccess}
        onCancel={() => {
          if (fromCreateInquiry) {
            return;
          }
          sendEvent(
            EventCategories.INQUIRY_SEND,
            'Send Inquiry - Cancel'
          );
          this.handleClose();
        }}
        footer={[
          <Button key="submit" type="primary"
            disabled={!isValidArray(checkedList) && !isValidArray(selectedStrategicFFs)}
            loading={this.state.isLoading} onClick={this.handleCreate}>
            Send
        </Button>,
          <Button key="back" onClick={() => {
            if (fromCreateInquiry) {
              sendEvent(
                EventCategories.INQUIRY_CREATION,
                'Create Inquiry - Skip Now',
              );
            } else {
              sendEvent(
                EventCategories.INQUIRY_SEND,
                'Send Inquiry - Cancel'
              );
            }
            this.handleClose();
          }}>
            {fromCreateInquiry ? 'Skip Now' : 'Cancel'}
          </Button>,
        ]}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: (fromCreateInquiry ?
        'center' : undefined) }}>

          {(fromCreateInquiry) ? this.getFlagComponent()
            : <Row>
            <Col span={10}>
              <h1 style={{ fontSize: `${tokens.fontSize.h3}px`, color: '#1875F0', fontWeight: 'bold' }}>
                {this.props.referenceNumber}</h1>
            </Col>
            <Col span={14}>
              <div style={{
                paddingTop: '4px', marginLeft: '64px',
                height: '40px', width: '173px',
              }}>
                {this.props.deadline &&
                  <div><Icon type="hourglass" style={{
                    height: '0.78px', width: '0.78px',
                    float: 'left',
                  }} />
                    <span style={{
                      fontSize: `${tokens.fontSize.small}px`, fontFamily: 'Open Sans', float: 'left',
                      paddingLeft: '25px',
                    }}>
                      {(() => {
                        const deadlineMoment =  this.props.timezone
                          ? momentTimezone(this.props.deadline).tz(this.props.timezone)
                          : this.props.deadline ? moment(this.props.deadline) : null;
                        return deadlineMoment ? deadlineMoment.format('DD MMM, YYYY | HH:mm ') + 'Hrs' : '';
                      })()}
                    </span>
                  </div>
                }
              </div>
            </Col>
          </Row>}
          {this.renderFFSelection()}
          {showDiscoverBuyRates && !hideStrategicVendors &&
            fetchingFFs &&
            !isValidArray(strategicFFs) && <Spin style={{ marginTop: '10px' }} />}
        </div>
      </Modal >
    );
  }
}

const mapStateToProps = ({ masterData, inquiryReducer }, ownProps) => {
  return {
    ffList: getFFDimensions(masterData),
    countriesList: inquiryReducer.masterData.countriesList,
    showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
    hideStrategicVendors: masterData.modules.hide_strategic_vendors,
    vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
    timezone: masterData.timezone,
  };
};

const SendRFQStyled = injectSheet(styles)(SendRFQ);
export default connect(mapStateToProps, null)(withRouter(SendRFQStyled));
